// extracted by mini-css-extract-plugin
module.exports = {"root":"ratio-image_root__lp_z8","imageContainer":"ratio-image_imageContainer__QWedH","image":"ratio-image_image__AJGSH"};